import { render, staticRenderFns } from "./setMenuInfo.vue?vue&type=template&id=2f1eb7ff&scoped=true"
import script from "./setMenuInfo.vue?vue&type=script&lang=js"
export * from "./setMenuInfo.vue?vue&type=script&lang=js"
import style0 from "./setMenuInfo.vue?vue&type=style&index=0&id=2f1eb7ff&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f1eb7ff",
  null
  
)

export default component.exports